/**
 * Buttons of « Notifications sur cet appareil ».
 *
 * Why this file exists: the shadcn `Button` default variant is `bg-primary text-primary-foreground`,
 * but the Tailwind theme defines `primary` (navy #1D3557) and NO `primary-foreground`, so the
 * text colour was never set and the label stayed dark on navy (≈1:1). These classes name every
 * colour explicitly, with Ridalo's palette, and every pairing is checked for WCAG AA (4.5:1)
 * in pwa-buttons.test.js.
 *
 *   primary   navy #1D3557 + white   (12.3:1)  hover #2A4A73 (9.0:1)  pressed #152840
 *   secondary white + navy, navy 1px border (12.3:1); hover = the primary look
 *   disabled  slate-200 + slate-600  (6.3:1) — plainly "off", still readable
 *   focus     2px navy ring with a white offset (visible on both light and navy buttons)
 *   size      ≥ 44px high (iPhone tap target), full width on a phone, label wraps instead of overflowing
 */
const BASE = [
  'inline-flex items-center justify-center gap-2 rounded-full min-h-[44px] px-5 py-2.5',
  'text-sm font-semibold text-center leading-tight w-full sm:w-auto',
  'transition-colors duration-150 disabled:cursor-not-allowed',
  'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2 focus-visible:ring-offset-white',
].join(' ');

export const PUSH_BUTTON = {
  primary: `${BASE} bg-primary text-white hover:bg-primary-light active:bg-primary-dark disabled:bg-slate-200 disabled:text-slate-600 disabled:hover:bg-slate-200`,
  secondary: `${BASE} bg-white text-primary border border-primary hover:bg-primary hover:text-white active:bg-primary-dark active:text-white disabled:bg-slate-100 disabled:text-slate-600 disabled:border-slate-300 disabled:hover:bg-slate-100 disabled:hover:text-slate-600`,
};
